import { ensureCsrfToken } from "./apiClient";
import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function authHeaders() {
  return { "Content-Type": "application/json" };
}

function base(clientViewId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/analytics`;
}

async function parse(response, fallback) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || fallback);
    error.code = body.code || null;
    error.statusCode = response.status;
    throw error;
  }
  return body;
}

function queryString(query = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value != null && value !== "") params.set(key, String(value));
  }
  const text = params.toString();
  return text ? `?${text}` : "";
}

export async function listAnalyticsMetrics(clientViewId, query = {}) {
  const response = await fetch(`${base(clientViewId)}/metricas${queryString(query)}`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudieron cargar las métricas.");
}

export async function getExecutiveAnalyticsDashboard(clientViewId, query = {}) {
  const response = await fetch(`${base(clientViewId)}/ejecutivo${queryString(query)}`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudo cargar el panel ejecutivo.");
}

export async function getCoverageAnalyticsDashboard(clientViewId, query = {}) {
  const response = await fetch(`${base(clientViewId)}/cobertura${queryString(query)}`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudo cargar el panel de cobertura.");
}

export async function getLeadAnalyticsDashboard(clientViewId, query = {}) {
  const response = await fetch(`${base(clientViewId)}/solicitudes${queryString(query)}`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudo cargar el panel de solicitudes.");
}

export async function getQueueAnalyticsDashboard(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/colas`, {
    credentials: "include",
    headers: authHeaders(),
  });
  return parse(response, "No se pudo cargar el panel de colas.");
}

export async function createAnalyticsExport(clientViewId, payload) {
  const token = await ensureCsrfToken();
  const response = await fetch(`${base(clientViewId)}/exportaciones`, {
    method: "POST",
    credentials: "include",
    headers: { ...authHeaders(), "X-CSRF-Token": token },
    body: JSON.stringify(payload),
  });
  return parse(response, "No se pudo crear la exportación.");
}

export async function enableVendorDirectoryAnalytics(clientViewId, payload = {}) {
  const token = await ensureCsrfToken();
  const response = await fetch(`${base(clientViewId)}/habilitar`, {
    method: "POST",
    credentials: "include",
    headers: { ...authHeaders(), "X-CSRF-Token": token },
    body: JSON.stringify(payload),
  });
  return parse(response, "No se pudo activar la analítica.");
}
